<template>
    <AdminNextIframe
        :path="`/discounts/${$route.params.subPath || ''}`"
        :query="{ clientId: $route.params.id }"
        @navigate="onNavigate"
        @back="onBack" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientDiscounts',
    components: { AdminNextIframe },
    methods: {
        onNavigate(path) {
            const match = path.match(/^\/discounts\/?(.*)$/);
            if (!match) return;
            const subPath = match[1] || undefined;
            this.$router.replace({
                name: 'client-discounts',
                params: { ...this.$route.params, subPath }
            }).catch(() => {});
        },
        onBack() {
            this.$router.push({
                name: 'client-recommerce',
                params: { id: this.$route.params.id }
            });
        }
    }
}
</script>
